import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getAccountLendingTypes, saveBatchAccountLendingTypes } from '../../api/accountLendingTypes';
import type { AccountLendingType } from '../../types/AccountLendingType';
import { t } from '../../i18n/t';

const columnDefs: ColDef<AccountLendingType>[] = [
  {
    field: 'accountLendingTypeId',
    headerName: t('accountLendingTypes.columns.accountLendingTypeId'),
    width: 140,
    cellDataType: 'number',
    editable: (p: EditableCallbackParams<AccountLendingType>) =>
      (p.data as { __status?: string } | undefined)?.__status === 'added',
    sort: 'asc',
  },
  { field: 'accountLendingTypeName', headerName: t('accountLendingTypes.columns.accountLendingTypeName'), flex: 1, editable: true },
];

const newRowDefaults = (): Partial<AccountLendingType> => ({ accountLendingTypeId: 0, accountLendingTypeName: '' });

export function AccountLendingTypesPage() {
  return (
    <LopCrudPage<AccountLendingType>
      resourceCode="accountLendingTypes"
      titleKey="accountLendingTypes.pageTitle"
      idField="accountLendingTypeId"
      getRows={getAccountLendingTypes}
      saveBatch={(added, modified, deletedIds) => saveBatchAccountLendingTypes(added, modified, deletedIds as number[])}
      columnDefs={columnDefs}
      newRowDefaults={newRowDefaults}
    />
  );
}
